module.exports = __webpack_public_path__ + "svg/stomach-rounder.3ba4a56250289fc0304d581907ebbda4.svg";